import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  exportReferrals,
  fetchCurrentUser,
  getReferralCategoryInfo,
  recalculate,
  resetReferralInfo,
  unassignAllKeywords
} from "./redux/referralCategoriesSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { Delete } from "./smartComponents/Delete";
import { Info } from "./smartComponents/Info";
import { UploadReferrals } from "./smartComponents/UploadReferrals";
import { Dialog } from "./smartComponents/Dialog";
import { Trash } from "../../../../assets/images/svg";
import { usePopup } from "./hooks/usePopup";
import "./referralCategories.scss";

export function ReferralCategoriesModule({ params }) {
  const dispatch = useDispatch();
  const { popup, openPopup, closePopup } = usePopup();

  const isLoading = useSelector((state) => state.referralCategories.isLoading);
  const referralCategories = useSelector((state) => state.referralCategories.referralCategories);
  const { canRecalculateValues, canExport, canImport, canUnassignAll, canShow, canUnassign } =
    useSelector((state) => state.referralCategories.actions);

  const [selectedReferral, setSelectedReferral] = useState(null);
  //for opening collapsible element
  const [referralId, setReferralId] = useState(null);

  const handleReferralCategory = (id, keywordsCount, clientsCount) => {
    if (!canShow) {
      return;
    }
    if (id === referralId) {
      setReferralId(null);
      dispatch(resetReferralInfo());
    } else {
      setReferralId(id);
      dispatch(getReferralCategoryInfo({ id, keywordsCount, clientsCount }));
    }
  };

  const onUnassignAll = () => {
    dispatch(unassignAllKeywords(selectedReferral.id));
    setSelectedReferral(null);
  };

  const onRecalculate = () => {
    dispatch(recalculate());
  };

  const onExport = () => {
    dispatch(exportReferrals());
  };

  useEffect(() => {
    dispatch(fetchCurrentUser(params));
  }, []);

  if (isLoading)
    return (
      <div className="light">
        <LoadingAnimation />
      </div>
    );

  return (
    <div className="referral-categories">
      <div className="referral-categories__top">
        {canRecalculateValues && (
          <button className="button button--primary" onClick={() => openPopup("recalculate")}>
            Recalculate Values
          </button>
        )}
        {canExport && (
          <button className="button button--primary" onClick={() => openPopup("export")}>
            Export
          </button>
        )}
        {canImport && (
          <button className="button button--primary " onClick={() => openPopup("upload")}>
            Import
          </button>
        )}
      </div>

      <div className="referral-categories__content">
        <ul className="group">
          {referralCategories.map(({ id, name, keywordsCount, clientsCount }) => {
            const keywordText = `${keywordsCount} keyword${keywordsCount != 1 ? "s" : ""}`;
            const clientsText = `${clientsCount} client${clientsCount != 1 ? "s" : ""}`;

            return (
              <Fragment key={id}>
                <li
                  color="dark"
                  className={`group__item ${!canShow ? "group__item--no-pointer" : ""}`}
                  onClick={() => handleReferralCategory(id, keywordsCount, clientsCount)}
                >
                  <div className="group__el text">
                    {name} ({keywordText}, {clientsText})
                  </div>
                  {canUnassignAll && (keywordsCount || clientsCount) ? (
                    <div className="group__el delete">
                      <span
                        className="group__icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedReferral({ id, name });
                        }}
                        title="Delete"
                      >
                        <Trash color="#FF0000" />
                      </span>
                    </div>
                  ) : null}
                </li>
                {id === referralId ? (
                  <Info referralCategoryId={id} canUnassign={canUnassign} />
                ) : null}
              </Fragment>
            );
          })}
        </ul>
      </div>

      {selectedReferral && (
        <Delete onClose={() => setSelectedReferral(null)} primaryBtnHandler={onUnassignAll}>
          Are you sure to delete all <span className="text-bold">{selectedReferral.name}</span>{" "}
          keywords?
        </Delete>
      )}

      {popup.recalculate && (
        <Dialog onClose={closePopup("recalculate")} primaryBtnHandler={onRecalculate}>
          Are you sure to recalculate referral categories?
        </Dialog>
      )}

      {popup.export && (
        <Dialog onClose={closePopup("export")} primaryBtnHandler={onExport}>
          Are you sure to export referral categories?
        </Dialog>
      )}

      {popup.upload && <UploadReferrals onClose={closePopup("upload")} />}
    </div>
  );
}
